import { api } from '@/api/client';
import { dateTime, num } from '@/lib/format';

type ExportShipment = {
  id: string;
  shipmentNo: string;
  shippedAt: string;
  logisticsCompany: string | null;
  trackingNo: string | null;
  note: string | null;
  order: { orderNo: string; customer: { name: string } };
  warehouse: { name: string };
  createdBy: { name: string } | null;
  lines: {
    quantity: number | string;
    lossQuantity: number | string;
    product: { code: string; name: string };
  }[];
};

type ExportResult = { items: ExportShipment[]; total: number };

function csvCell(value: string | number) {
  const plain = String(value);
  // 业务字段可能由外部订单或物流平台录入，避免表格软件将其当成公式执行。
  const safe = /^[\s\u0000-\u001f]*[=+\-@]/.test(plain) ? `'${plain}` : plain;
  return `"${safe.replaceAll('"', '""')}"`;
}

export async function exportLogistics(query: { keyword?: string; period: '30d' | 'all'; warehouseId?: string; exception?: 'open'; orderNo?: string; ids?: string[] }) {
  const { orderNo, ids, ...filters } = query;
  const result = await api.get<ExportResult>('/api/v2/shipments/ledger', { ...filters, ids: ids?.join(','), export: '1' });
  // 订单详情的导出只包含当前订单，不让关键词包含匹配带入其他订单。
  const shipments = result.items.filter((shipment) => (!orderNo || shipment.order.orderNo === orderNo) && (!ids || ids.includes(shipment.id))); 
  const rows: (string | number)[][] = [[
    '业务订单', '客户', '仓库', '发货批次', '发货时间', '物流公司', '物流单号',
    '产品编号', '产品名称', '发货数量', '破损/补耗', '实际出库', '出库人', '备注',
  ]];
  for (const shipment of shipments) {
    const lines = shipment.lines.length ? shipment.lines : [null];
    for (const line of lines) {
      const quantity = line ? num(line.quantity) : 0;
      const loss = line ? num(line.lossQuantity) : 0;
      rows.push([
        shipment.order.orderNo, shipment.order.customer.name, shipment.warehouse.name,
        shipment.shipmentNo, dateTime(shipment.shippedAt), shipment.logisticsCompany || '', shipment.trackingNo || '',
        line?.product.code || '', line?.product.name || '', quantity, loss, quantity + loss,
        shipment.createdBy?.name || '', shipment.note || '',
      ]);
    }
  }
  const csv = '\uFEFF' + rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `发货物流-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return orderNo || ids ? shipments.length : result.total;
}
